import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contextos/AuthContext';
import Loader from '../../telas/loader/Loader';

/**
 * Protege as rotas do app. Enquanto a sessão inicial carrega, mostra o Loader;
 * sem sessão, manda para a landing. Fonte de verdade: AuthContext.
 */
export default function RotaProtegida({ children }: { children: ReactNode }) {
  const { autenticado, carregando } = useAuth();

  if (carregando) return <Loader />;
  if (!autenticado) return <Navigate to="/entrar" replace />;
  return <>{children}</>;
}
